import { ApiMethodSignature } from 'types/swagger/clarifai-api';

export enum Language {
  PythonSDK = 'Python (SDK)',
  Python = 'Python',
  Javascript = 'Javascript',
  Java = 'Java',
  NodeJS = 'NodeJS',
  NodeJS_SDK = 'NodeJS (SDK)',
  cURL = 'cURL',
  PHP = 'PHP',
}

export enum ModelLanguage {
  PythonSDK = 'Python (SDK)',
  Python = 'Python',
  PythonOpenAI = 'Python (OpenAI)',
  PythonMCP = 'Python (MCP)',
  Javascript = 'Javascript',
  Java = 'Java',
  NodeJS = 'NodeJS',
  NodeJS_SDK = 'NodeJS (SDK)',
  NodeJSVercel = 'NodeJS (Vercel AI SDK)',
  NodeJSOpenAI = 'NodeJS (OpenAI)',
  cURL = 'cURL',
  PHP = 'PHP',
}

export enum InputType {
  text = 'text',
  image = 'image',
  audio = 'audio',
  video = 'video',
}

// Remove enums "WorkflowSupportedLanguages" and "WorkflowSupportedInputTypes"
// when working on : https://clarifai.atlassian.net/browse/MRK-2932
export enum WorkflowSupportedLanguages {
  PythonSDK = 'Python (SDK)',
  Python = 'Python',
  Java = 'Java',
  NodeJS = 'NodeJS',
  NodeJS_SDK = 'NodeJS (SDK)',
  cURL = 'cURL',
}

export enum WorkflowSupportedInputTypes {
  text = 'text',
  image = 'image',
  audio = 'audio',
}

type BaseSnippetProps = {
  pat: string;
  userId: string;
  appId: string;
  inputUrl: string;
  apiHost: string;
};

export type ModelSnippetProps = BaseSnippetProps & {
  modelId: string;
  modelVersionId: string;
  deploymentId?: string;
  method_signatures?: ApiMethodSignature[];
};

export type WorkflowSnippetProps = BaseSnippetProps & {
  workflowId: string;
};

export type ModelSnippetFn = (props: ModelSnippetProps) => string;

export type WorkflowSnippetFn = (props: WorkflowSnippetProps) => string;

export type ModelSnippets = Record<Language, Record<InputType, ModelSnippetFn>>;

export type WorkflowSnippets = Record<WorkflowSupportedLanguages, Record<WorkflowSupportedInputTypes, WorkflowSnippetFn>>;
